import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router}  from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import cardReducer from './reducers/cardReducer'

export const url = 'https://anime-rankr.herokuapp.com'

ReactDOM.render(
  <DndProvider backend={HTML5Backend}>
    <React.StrictMode>
      <Router>
        <Provider store={createStore(cardReducer, applyMiddleware(thunk))}>
          <App/>
        </Provider>
      </Router>
    </React.StrictMode>
  </DndProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
